const wrapper = "_35sw7snyfw";
const item = "_35siwwie3k";
const bullet = "_35sbuomfue";
const bulletIcon = "_35sbbnsr9d";

export { bullet, bulletIcon, item, wrapper };
import "./atom.legend.style.linaria.module.css";
//# sourceMappingURL=atom.legend.style.js.map
